export default function Section1() {
  return (
    <div className="w-full bg-white Section1 py-[30px] md:py-[50px]">
      {/* Main Page Heading */}
      <h1 className="text-center text-black text-[32px] md:text-[42px] font-bold mb-20 leading-[32px] md:leading-[41px]">
        Web Development Services
      </h1>

      {/* Hero Content */}
      <div className="w-[90%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        {/* Left Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-[26px] md:text-[30px] font-bold text-[#DA2128] -mt-10 md:mt-[0] leading-[34px] md:leading-[34px] mb-6">
            World-Class Web Development Agency for Growing Brands
          </h2>

          <p className="text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-10 max-w-[500px] mx-auto md:mx-0">
            We provide professional website design and development services, building scalable,
            high-performing websites and apps that increase conversions and drive global growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="https://mean3.com/contact-mean3" // replace with your target URL
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
            >
              Get a Free Consultation
            </a>
            <a
              href="https://mean3.com/contact-mean3" // replace with your target URL
              className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
            >
              View Our Work
            </a>
          </div>

        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="/assets/e-commerce-journey-WebDevPage.png" // Replace with your actual image
            alt="Web Development Illustration"
            className="w-[90%] md:w-[80%] max-w-[500px] h-auto"
          />
        </div>
      </div>
    </div>
  );
}
